export const aciTrains = {
    iconName: 'trains',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M6.948 2.979c-.36 0-.704.148-.958.413a1.438 1.438 0 00-.396.996v12.815a.47.47 0 00.129.325.433.433 0 00.313.135h13.233c.117 0 .23-.048.313-.135a.47.47 0 00.13-.325V4.388c0-.374-.144-.732-.398-.996a1.329 1.329 0 00-.958-.413H6.948zm-1.623-.28C5.755 2.252 6.339 2 6.948 2h11.408c.61 0 1.193.252 1.624.7.43.447.672 1.055.672 1.688v12.815c0 .382-.145.748-.405 1.018s-.611.421-.978.421H6.036c-.367 0-.72-.151-.979-.421a1.469 1.469 0 01-.405-1.018V4.388c0-.633.242-1.24.673-1.689z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.553 18.082c.208.162.25.47.094.686l-2.19 3.037a.459.459 0 01-.66.098.502.502 0 01-.093-.685l2.19-3.038a.459.459 0 01.659-.098zM16.75 18.082a.459.459 0 01.66.098l2.19 3.038a.502.502 0 01-.094.685.459.459 0 01-.659-.098l-2.19-3.037a.503.503 0 01.094-.686z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M18.128 20.862H7.176v-.98h10.952v.98zM8.96 14.393a.638.638 0 00-.624.65c0 .359.28.65.624.65.345 0 .625-.291.625-.65 0-.36-.28-.65-.625-.65zm-1.565.65c0-.9.7-1.629 1.565-1.629s1.566.73 1.566 1.629c0 .9-.7 1.628-1.566 1.628-.864 0-1.565-.729-1.565-1.628zM16.277 14.393a.638.638 0 00-.625.65c0 .359.28.65.625.65s.624-.291.624-.65c0-.36-.28-.65-.624-.65zm-1.566.65c0-.9.701-1.629 1.566-1.629.864 0 1.566.73 1.566 1.629 0 .9-.701 1.628-1.566 1.628-.865 0-1.566-.729-1.566-1.628zM7.07 5.78c0-.81.632-1.468 1.412-1.468h8.34c.78 0 1.411.658 1.411 1.469v4.877c0 .81-.632 1.468-1.412 1.468H8.482c-.78 0-1.412-.657-1.412-1.468V5.78zm1.412-.489a.48.48 0 00-.47.49v4.877c0 .27.21.49.47.49h8.34c.26 0 .47-.22.47-.49V5.78a.48.48 0 00-.47-.49h-8.34z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
